import { useFirebaseData } from "../../@shared/hooks/useFirebaseData";
import { useEffect, useState } from "react";
import { IService } from "../interfaces/IService";
import { useNavigate } from "react-router-dom";
import { Collections } from "../constants/FirebasePaths";

const useService = (serviceId: string) => {
  const [service, setService] = useState<IService>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const router = useNavigate();
  const db = useFirebaseData({
    collectionPath: `services`
  });

  const getService = async () => {
    setIsLoading(true);

    if (!serviceId) {
      redirectToHome()
      return;
    }
    let serviceData: IService = await db.docWithId(`services/${serviceId}`);

    if (!serviceData) {
      redirectToHome()
      return;
    }

    serviceData.company = await db.docWithId(serviceData.company.path);
    serviceData.details.location = await db.docWithId(serviceData.details.location.path);
    serviceData.details.provider = await db.docWithId(`${Collections.users._path}/${serviceData.details.provider.id}`);

    setService(serviceData as IService);
    setIsLoading(false);
  };

  const redirectToHome = () => {
    setIsLoading(false);
    router("/");
  }

  useEffect(() => {
    getService();
  }, []);

  return {
    service,
    isLoading
  };
};

export default useService;
